import * as React from 'react';
import { AppAppBarCommon } from './AppAppBarCommon';

export default function AppAppBar() {
  return <AppAppBarCommon />;
}
